/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type SharedProductCarouselItem_edge$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type SharedProductCarousel_collectionsModules$ref: FragmentReference;
export type SharedProductCarousel_collectionsModules = {|
  +title: ?string,
  +itemsConnection: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +serviceId: ?string
      |},
      +$fragmentRefs: SharedProductCarouselItem_edge$ref,
    |}>
  |},
  +$refType: SharedProductCarousel_collectionsModules$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SharedProductCarousel_collectionsModules",
  "type": "CollectionsModulesPhotoCarousel",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "itemsConnection",
      "storageKey": null,
      "args": null,
      "concreteType": "CmsItemsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CmsItemsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "SharedProductCarouselItem_edge",
              "args": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Item",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "serviceId",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '4a59ad7d29962b083d73ec73633970b1';
module.exports = node;
